export default __webpack_public_path__ + "static/media/audio-preview.f601d4e7.svg";